module.exports = __webpack_public_path__ + "static/d-EChavarria-4ac4190f05532d60496ccdddb7fac76d.jpg";